export const birthNationalityType = Object.freeze({
    CHILD: 'child',
    PARENT: 'parent',
})
